import React, { useState, useEffect, useRef } from 'react';
import {
  Row,
  Input,
  Card,
  CardBody,
  Label,
  Col,
  Button,
  InputGroup,
} from 'reactstrap';
import { DataTable, Column } from 'vivace-fluent-motion';
import SelectComponent from '@componentes/select/select.component';
import { useDispatch, useSelector } from 'react-redux';
import * as organizarActions from '../store/organizar.action';
import * as commonActions from '@common/common.action';
import { quadroKanbanEnum } from '@common/util/defaultValues';
import { Switch, FormControlLabel } from '@material-ui/core';
import DragDropApi from '../../dragdrop.api';
import IntlMessage from "../../../../helpers/intlMessage";
import { useIntl } from 'react-intl';

export default function Imunologia(props) {
  const intl = useIntl();

	function translate(key) {
	  return intl.formatMessage({ id: key });
	}
  const [destino, setDestino] = useState([]);
  const [destinos, setDestinos] = useState([]);
  const [selectGrid, setSelectGrid] = useState(0);
  const [identificacao, setIdentificacao] = useState();
  const [isAutoInput, setIsAutoInput] = useState(false);
  const organizarLote = useSelector((state) => state.organizarLote);
  const dispatch = useDispatch();

  const componentRef = useRef();

  useEffect(() => {
    const data = props.data[Object.keys(props.data)[0]];
    if (data && data.length > 0) {
      reset();
      insertSelect(data);
    }
  }, [props.data]);

  useEffect(() => {
    dispatch(organizarActions.atualizarLista([]));
  }, []);

  useEffect(() => {
    function montarColunas(list) {
      let colunas = [];
      // eslint-disable-next-line array-callback-return
      list.map((item, key) => {
        colunas.push({
          label: item.title.text,
          value: Object.keys(item)[0],
        });
      });
      props.lista.length > 0 && setDestinos(colunas);
    }
    montarColunas(props.lista);
  }, [props.lista]);

  useEffect(() => {
    const disabled = !selectGrid || destino.length === 0;
    dispatch(organizarActions.atualizarMoverDisabled(disabled));
  }, [selectGrid, destino]);

  useEffect(() => {
    if (props.click) {
      moverItens();
    }
  }, [props.click]);

  function reset() {
    dispatch(organizarActions.atualizarLamina([]));
    dispatch(organizarActions.atualizarMoverDisabled(true));
    // setLista([]);
    dispatch(organizarActions.atualizarLista([]));
    setSelectGrid(0);
    setDestino([]);
  }

  useEffect(() => {
    const data = props.data[Object.keys(props.data)[0]];
    if (organizarLote.laminas.length > 0 && data.length > 0) {
      insertSelect(data);
    }
  }, [organizarLote]);

  useEffect(() => {
    componentRef.current && componentRef.current.focus();
  });

  function selectItem(e) {
    let tr = document.getElementsByTagName('tr');
    let checkboxes = document
      .getElementsByClassName('kanban-imunologia-organizar-table')[0]
      .querySelectorAll('input[name=checkbox]:checked');
    setSelectGrid(checkboxes.length);
    let items = document
      .getElementsByClassName('kanban-imunologia-organizar-table')[0]
      .getElementsByTagName('tr').length;
    if (checkboxes.length < items - 1) {
      document.getElementById('selectMaterias').checked = false;
    } else {
      document.getElementById('selectMaterias').checked = true;
    }
    for (let i = 0; i < tr.length - 1; i++) {
      if (
        document.getElementsByTagName('tr')[i + 1].getElementsByTagName('td')
          .length > 0 &&
        document
          .getElementsByTagName('tr')[i + 1].getElementsByTagName('td')[0]
          .getElementsByTagName('input')[0]
      ) {
        if (
          document
            .getElementsByTagName('tr')[i + 1].getElementsByTagName('td')[0]
            .getElementsByTagName('input')[1].id === e.target.id
        ) {
          if (
            document
              .getElementsByTagName('tr')[i + 1].getAttribute('datacheck') === 'true'
          ) {
            document
              .getElementsByTagName('tr')[i + 1].setAttribute('datacheck', 'false');
          } else {
            document
              .getElementsByTagName('tr')[i + 1].setAttribute('datacheck', 'true');
          }
        }
      }
    }
  }

  function onChangeSelect(e) {
    let tr = document.getElementsByTagName('tr');
    for (let i = 0; i < tr.length - 1; i++) {
      if (
        document.getElementsByTagName('tr')[i + 1].getElementsByTagName('td')
          .length > 0 &&
        document
          .getElementsByTagName('tr')[i + 1].getElementsByTagName('td')[0]
          .getElementsByTagName('input')[0]
      ) {
        if (
          document
            .getElementsByTagName('tr')[i + 1].getElementsByTagName('td')[0]
            .getElementsByTagName('input')[1].id === e.data.itemId.toString()
        ) {
          if (
            document
              .getElementsByTagName('tr')[i + 1].getAttribute('datacheck') === 'true'
          ) {
            document
              .getElementsByTagName('tr')[i + 1].setAttribute('datacheck', 'false');
            document.getElementById(e.data.itemId.toString()).checked = false;
          } else {
            document
              .getElementsByTagName('tr')[i + 1].setAttribute('datacheck', 'true');
            document.getElementById(e.data.itemId.toString()).checked = true;
          }
        }
      }
    }
    let checkboxes = document
      .getElementsByClassName('kanban-imunologia-organizar-table')[0]
      .querySelectorAll('input[name=checkbox]:checked');
    setSelectGrid(checkboxes.length);
    let items = document
      .getElementsByClassName('kanban-imunologia-organizar-table')[0]
      .getElementsByTagName('tr').length;
    if (checkboxes.length < items - 1) {
      document.getElementById('selectMaterias').checked = false;
    } else {
      document.getElementById('selectMaterias').checked = true;
    }
  }

  function toggleCheckBox(checked) {
    let checkboxes = document
      .getElementsByClassName('kanban-imunologia-organizar-table')[0]
      .getElementsByClassName('checkbox');
    for (let i = 0; i < checkboxes.length; i++) {
      if (checkboxes[i] !== checked) {
        checkboxes[i].checked = checked;
        let doc = document
          .getElementsByClassName('kanban-imunologia-organizar-table')[0]
          .getElementsByTagName('tr')[i + 1];
        if (checked) {
          setSelectGrid(checkboxes.length);
          doc && doc.setAttribute('datacheck', 'true');
        } else {
          setSelectGrid(0);
          doc && doc.setAttribute('datacheck', 'false');
        }
      }
    }
  }

  function removerItem(id) {
    let draft = organizarLote.lista;
    let index = draft.findIndex((x) => x.id === id);
    draft.splice(index, 1);
    dispatch(organizarActions.atualizarLista(draft));
  }

  function insertSelect(dados) {

    const novaLista = organizarLote.lista;
    let novoItem = {
      id: dados.idlamina,
      itemId: dados.idlamina,
      exame: dados.dsCasoLamina,
      bloco: dados.nrBloco,
      medico: dados.nome,
      nomeExame: dados.tipo,
      nomePaciente: dados.nomePaciente,
      lamina: dados.dsCasoLamina,
      remove: (
        <Button onClick={() => removerItem(dados.idlamina)}>
          <i className="mv-basico-apagar"></i>
        </Button>
      ),
      select: (
        <input
          className="checkbox"
          name="checkbox"
          type="checkbox"
          id={`lamina_${dados.idlamina}_${dados.cdRequisicao}`}
          onClick={(e) => selectItem(e)}
        />
      ),
    };

    let itemJaIncluido = novaLista.some(
      (item, key) => novoItem.itemId === item.itemId);

    if (itemJaIncluido) {
      dispatch(
        commonActions.showAlerta(
          'alerta',
          <IntlMessage id="dashboards.sample.thisItemHasAdded" />,
          3000
        ));
    } else {
      novaLista.push(novoItem);
      dispatch(organizarActions.atualizarLista(novaLista));
    }

    dispatch(commonActions.showFadeCarregando(false));
  }

  function getIconeStatus(value) {
    let icone, status;

    if (
      Object.keys(props.lista[0])[0] === quadroKanbanEnum.CG_PENDENTES.id &&
      value === quadroKanbanEnum.CG_EXECUTANDO.id
    ) {
      icone = quadroKanbanEnum.CG_EXECUTANDO.icone;
      status = quadroKanbanEnum.CG_EXECUTANDO.status;
    } else if (
      Object.keys(props.lista[0])[0] === quadroKanbanEnum.CG_PENDENTES.id &&
      value === quadroKanbanEnum.CG_PRONTAS.id
    ) {
      icone = quadroKanbanEnum.CG_PRONTAS.icone;
      status = quadroKanbanEnum.CG_PRONTAS.status;
    } else if (
      Object.keys(props.lista[0])[0] === quadroKanbanEnum.CG_PENDENTES.id &&
      value === quadroKanbanEnum.CG_PENDENTES.id
    ) {
      icone = quadroKanbanEnum.CG_PENDENTES.icone;
      status = quadroKanbanEnum.CG_PENDENTES.status;
    }

    return { icone, status };
  }

  function montarLaminas(itens, destination) {
    let laminas = [];
    for (let item of itens) {
      let lamina = item.id.split('_');
      const iconeStatus = getIconeStatus(destination);
      laminas.push({
        CdRequisicaoImuno: +lamina[2],
        lamina: +lamina[1],
        status: iconeStatus.status,
      });
    }
    return laminas;
  }

  async function moverItens() {
    const data = document
      .getElementsByClassName('kanban-imunologia-organizar-table')[0]
      .querySelectorAll('input[name=checkbox]:checked');

    // Citologia
    const payload = montarLaminas(data, destino.value);
    const laminas = { laminas: payload };
    const sendLaminas = await DragDropApi.moverLaminas(laminas);

    if (sendLaminas.success) {
      dispatch(organizarActions.atualizarNovasLaminas(sendLaminas.success));

      dispatch(commonActions.showAlerta(
        'sucesso',
        <IntlMessage id="dashboards.sample.itemsMovedSuccessfully" />,
        2000
      ));
    }

    return dispatch(organizarActions.atualizarModal(false));
  }

  function changeAutoInput(e) {
    setIsAutoInput(e);
    setTimeout(() => {
      componentRef.current.focus();
    }, 600);
    setIdentificacao('');
  }

  function adicionarItem() {
    if (!identificacao) return;

    dispatch(commonActions.showFadeCarregando(true));
    identificacao &&
      DragDropApi.getLaminasImuno(identificacao).then((res) => {
        insertSelect(res.data);
      });
    setIdentificacao('');
  }

  function changeIdentificacao(e) {
    let nrLamina = e;
    if (isAutoInput) {
      if (nrLamina && nrLamina.length > 3) {
        dispatch(commonActions.showFadeCarregando(true));
        DragDropApi.getLaminasImuno(nrLamina).then((res) => {
          insertSelect(res.data);
        });
      } else
        nrLamina && nrLamina.length > 3
          ? setIdentificacao('')
          : setIdentificacao(nrLamina);
      componentRef.current.focus();
    } else {
      setIdentificacao(nrLamina);
    }
  }

  function changeDestino(e) {
    setDestino(e);
  }

  return (
    <Card>
      <CardBody>
        <Row>
          <Col sm={'auto'} style={{ marginRight: 0 }}>
            <InputGroup>
              <Input
                innerRef={componentRef}
                style={{ borderRadius: '5px', fontSize: '13px' }}
                value={identificacao}
                placeholder={`${intl.formatMessage({ id: 'dashboards.cytology.identificationNumber' })}`}
                onChange={(e) => changeIdentificacao(e.target.value)}
              />
              <Button
                className="btn btn-primary"
                style={{ height: '38px', float: 'left' }}
                disabled={isAutoInput}
                onClick={adicionarItem}
              >
                <i className="icons-btn mv-basico-adicionar"></i>
              </Button>
            </InputGroup>
          </Col>

          <div className="col-4">
            <Label className="label-data col-auto" style={{ float: 'left' }}>
              <IntlMessage id="dashboards.cytology.destiny" />
            </Label>
            <SelectComponent
              onChange={(e) => changeDestino(e)}
              className="col-auto"
              value={destino}
              options={destinos}
              placeholder={translate("dashboards.cytology.selectDestiny")}
            />
          </div>

          <Col>
            <FormControlLabel
              control={
                <Switch
                  checked={isAutoInput}
                  onChange={(e) => changeAutoInput(e.target.checked)}
                  name="descarte-imprimir"
                  color="primary"
                />
              }
              label={<IntlMessage id="dashboards.histology.autoInput" />}
            />
          </Col>
        </Row>
        <br />
        <DataTable
          className="kanban-imunologia-organizar-table"
          onContextMenu={(e) => onChangeSelect(e)}
          value={organizarLote.lista}
          //pageLinkSize={20}
          responsive={true}
          selectionMode="single"
          style={{ height: '100%' }}
          columnResizeMode="expand"
          scrollable={true}
          //scrollHeight="50vh"
          scrollWidth="100%"
          //resizableColumns={listaDetalhes.length >= 1}
          //reorderableColumns={listaDetalhes.length >= 1}
          //rowsPerPageOptions={[10, 20, 50]}
          //rows={totalItensPage}
          lazy={true}
          paginator={false}
          //loading={carregando}
          //loadingIcon="mv-basico-menu_secundario"
          emptyMessage={<IntlMessage id="dashboards.reports.noResultsFound" />}
          alwaysShowPaginator={false}
          autoLayout={true}
        //footer={<RenderizarFooter total={totalItens} />}
        >
          <Column
            sortable={false}
            field="select"
            style={{ width: '25px', verticalAlign: 'middle' }}
            header={
              organizarLote.lista.length >= 1 && (
                <input
                  type="checkbox"
                  id="selectMaterias"
                  name="selectMaterias"
                  onChange={(e) => {
                    toggleCheckBox(e.target.checked);
                  }}
                />
              )
            }
          />

          <Column
            sortable={false}
            field="exame"
            style={{
              width: '150px',
              verticalAlign: 'middle',
            }}
            header={`${intl.formatMessage({id: 'general.materialArchiving.identification'})}`}
          />

          <Column
            sortable={false}
            field="bloco"
            style={{ width: '150px', verticalAlign: 'middle' }}
            header={<IntlMessage id="general.materialArchiving.block" />}
          />

          <Column
            sortable={false}
            field="medico"
            style={{ width: '180px', verticalAlign: 'middle' }}
            header={<IntlMessage id="dashboards.reports.doctor" />}
          />

          <Column
            style={{ width: 'auto', verticalAlign: 'middle' }}
            sortable={false}
            field="remove"
            header={<IntlMessage id="general.materialArchiving.remove" />}
          />
        </DataTable>
      </CardBody>
    </Card>
  );
}



// WEBPACK FOOTER //
// ./src/componentes/dragdrog/organizarLote/containers/imunologia.js